import { registerComponent } from "helpers";

registerComponent(
  "product-zoom-image",
  class ImageZoom extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth >= 1024) {
        this.bindEvents();
      }
    }

    bindEvents() {
      document.querySelectorAll("[data-zoom-image]").forEach((image) => {
        image.addEventListener("click", this.openZoom.bind(this), false);
      });

      this.addEventListener("mousemove", this.moveZoom.bind(this), false);

      this.addEventListener("click", this.closeZoom.bind(this), false);

      this.addEventListener("mouseleave", this.closeZoom.bind(this), false);
    }

    closeZoom(e) {
      this.style.display = "none";
      this.style.backgroundImage = "";
    }

    openZoom(e) {
      const image = e.target.dataset.zoomImage;
      this.style.backgroundImage = `url(${image})`;
      this.style.display = "block";
      this.moveZoom(e);
    }

    moveZoom(e) {
      const dimensions = e.target.getBoundingClientRect();
      const x = e.clientX - dimensions.left;
      const y = e.clientY - dimensions.top;
      const xPercent = Math.round(100 / (dimensions.width / x));
      const yPercent = Math.round(100 / (dimensions.height / y));

      this.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }
  },
);
